import { useTranslation } from 'react-i18next';

import { DocumentTextOutline, Flex, Text } from '@bonusly/design-system';

/**
 * Renders a compact pill/bar indicating a notes edit operation.
 *
 * This is ONLY the header indicator — the LLM's response text renders
 * separately below this as a regular BizyStreamingMessage. Matches the
 * Figma design: a bordered pill with document-text icon + "Updated 1:1 notes".
 */
export function BizyEditConfirmation() {
	const { t } = useTranslation('admin_bizy');

	return (
		<Flex align="center" gap={1} alignSelf="flex-start">
			<DocumentTextOutline boxSize={4} color="info.icon" />
			<Text fontSize="sm" fontWeight="medium" color="info.icon" lineHeight="20px">
				{t('edit_confirmation.title')}
			</Text>
		</Flex>
	);
}
